/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import appContext from "../../appContext";
import UserTemplates from "./UserTemplates";
import AddGroupPopup from "../../components/Popup/addGroupPopup";
import CustomizedInput from "../../components/CreateForm/InputBase";
import CustomizedSwitch from "../../components/CreateForm/SwitchBase";
import CustomizedColorInput from "../../components/CreateForm/ColorBase";
import HtmlIcon from "../../components/FormSettings/OptionalComponents/HtmlIcon";
import CustomizedSingleSelectDropdown from "../../components/CreateForm/DropdownBase";
import FileUploadDialog from "../../components/CreateForm/DialogBase/FileUploadDialog";
import SettingsIcon from "../../components/FormSettings/OptionalComponents/SettingsIcon";
import UserTemplatesDialog from "../../components/CreateForm/DialogBase/UserTemplatesDialog";
import InfoIcon from '@mui/icons-material/Info';
import { globalColors } from "../../Utils/colors";
import { useContext, useState, useEffect, useMemo } from "react";
import { ColorTextContainer } from "../../components/CustomCss/styled";
import { fields, getError, traceFormikErrorField } from "./formikutils";
import { useScrollToElement } from "../../CustomHooks/useScrollToElement";

import {
  getGroups,
  getHtmlContentBasedOnId,
  saveGroups,
} from "../../Services/API";

import {
  Alert,
  Divider,
  Grid,
  MenuItem,
  Select,
  Snackbar
} from "@mui/material";

import {
  Application,
  Department,
  Position,
  handleDropdownData,
} from "../../Utils/common";

import {
  BackgroundSettingsContainer,
  BasicSettingsContainer,
  CustomToolTip,
  ErrorText,
  ExtraHeaderText,
  FlexDiv,
  FormSettingsContainer,
  GeneralSettingsContainer,
  HeaderText,
  LandingPageSettingsContainer,
  TextContainer,
} from "./styled";

import {
  ChooseYourFileButton,
  ChooseExistingTemplateButton,
  EditButton,
  SelectableButton,
  AddGroupButton,
} from "../../components/Custom/Buttons";

import {
  LandingPageHtmlButtonWrapper,
  LandingPageTypeButtonsContainer,
} from "../../components/FormSettings/OptionalComponents/styled";
import InputChipComponent from "../../components/InputChipComponent/input";
import InfiniteScrollSelect from "../../components/InfiniteScrollSelect";

type toasterConfigType = {
  open: boolean;
  severity: "success" | "error" | "warning";
  message: string;
};

export default function CreateFormPopupContent({
  values,
  setDataFromModal,
  landingPage,
  setLandingPage,
  applicationPopupData,
  setApplicationPopupData,
  departmentPopupData,
  setDepartmentPopupData,
  watermarkPosition,
  setWatermarkPosition,
  watermark,
  setWatermark,
  recordVideo,
  setRecordVideo,
  showRecordVideo,
  setShowRecordVideo,
  sendResponseToUser,
  setSendResponseToUser,
  endPointAvailable,
  setEndPointAvailable,
  gaAvailable,
  setGaAvailable,
  gtmAvailable,
  setGtmAvailable,
  editUUID,
  saveContact,
  setSaveContact,
}: any) {
  const { scrollToElement } = useScrollToElement();
  const { groupsList, contactGroup, setContactGroup, setGroupsList } =
    useContext(appContext);

  const [editIdentifier, setEditIdentifier] = useState(null);
  const [uploadIdentifier, setUploadIdentifier] = useState(null);
  const [btnLoading, setBtnLoading] = useState<boolean>(false);
  const [groupResponse, setGroupResponse] = useState<string>("");
  const [groupPopupOpen, setGroupPopupOpen] = useState<boolean>(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const [templateIdentifier, setTemplateIdentifier] = useState<string | null>(
    null
  );

  const [toasterConfig, setToasterConfig] = useState<toasterConfigType>({
    open: false,
    severity: "success",
    message: "",
  });

  const onTemplateCloseHandler = () => {
    setTemplateIdentifier(null);
    setSelectedTemplateId("");
  };

  const onTemplateSubmitHandler = async () => {
    const content = await getHtmlContentBasedOnId(selectedTemplateId);
    const background = `https://pages.waymore.io/resources/${selectedTemplateId}/screenshot.jpg`;

    if (templateIdentifier === "1") {
      setValue(fields.landingPageHtml.setField, content);
      setValue(fields.landingPageBackground.setField, background);
    } else if (templateIdentifier === "2") {
      setValue(fields.thankyouPage.setField, content);
    }

    setValue(fields.templateId.setField, selectedTemplateId);
    setTemplateIdentifier(null);
  };

  const handleOnEditOpen = (identifier: any) => {
    setEditIdentifier(identifier);
  };

  const handleOnEditClose = () => {
    setEditIdentifier(null);
  };

  const handleOnUploadOpen = (identifier: any) => {
    setUploadIdentifier(identifier);
  };

  const handleOnUploadClose = (url: any) => {
    if (url) {
      setValue(uploadIdentifier, url);
      setUploadIdentifier(null);
    } else {
      setUploadIdentifier(null);
    }
  };

  const getValue = (fieldname: string) => {
    const field = values?.getFieldProps(fieldname);

    return field ? field.value : "";
  };

  const setValue = (fieldname: any, fieldvalue: any) => {
    values.setFieldValue(fieldname, fieldvalue);
  };

  const setTouched = (fieldname: string) => {
    values.setFieldTouched(fieldname, true);
  };

  const handleSave = async (value: string) => {
    try {
      if (value.length) {
        setBtnLoading(true);
        const saveGroupRes = await saveGroups({
          name: value,
        });
        if (saveGroupRes?.name) {
          await getGroups().then((group) => {
            setGroupsList(handleDropdownData(group?.data))
            if (group.page < group.totalPages) {
              setHasMore(true)
            }
            setPage(1)
          }
          );

          setGroupPopupOpen(false);
          setGroupResponse("");
          setToasterConfig({
            open: true,
            message: "Group created successfully",
            severity: "success",
          });
        } else {
          setToasterConfig({
            open: true,
            severity: "error",
           
            message: saveGroupRes?.err?.response?.data?.userId?.length
              ? saveGroupRes?.err?.response?.data?.userId[0]
              : saveGroupRes?.errors?.name[0] ? saveGroupRes?.errors?.name[0] : "Unable to create group",
          });
        }
      }

      setBtnLoading(false);
    } catch (error: any) {
      setBtnLoading(false);
      setToasterConfig({
        open: true,
        message: error?.message || "Something went wrong",
        severity: "error",
      });
    }
  };
  // Function to generate or update HTML content with styles
  const generateHtml = (html: string, alignHorizontal: boolean, alignVertical: boolean): string => {

    // Define the container's base style
    let containerStyles = 'width: 100vw; height: 100vh;';

    // Apply alignment styles based on flags
    if (alignVertical && alignHorizontal) {
      // If both alignments are true, center both ways using flex
      containerStyles += ' display: flex; align-items: center; justify-content: center;';
    } else if (alignVertical) {
      // Apply only vertical alignment
      containerStyles += ' display: flex; align-items: center;';
    } else if (alignHorizontal) {
      // Apply only horizontal alignment
      containerStyles += ' text-align: center;';
    }

    // Extract existing content without creating nested divs
    const contentMatch = html.match(/<div[^>]*>([\s\S]*?)<\/div>/);
    const content = contentMatch ? contentMatch[1].trim() : html.trim();

    // Return the final updated HTML
    return `<div style="${containerStyles}">${content}</div>`;
  }

  const isHorizontalAligned = (html: string): boolean => {
    const styleMatch = html.match(/style="([^"]*)"/);
    if (styleMatch) {
      const styles = styleMatch[1];
      return styles.includes('text-align: center;') || styles.includes('justify-content: center;');
    }
    return false;
  };

  // Function to detect if vertical alignment style is applied
  const isVerticalAligned = (html: string): boolean => {
    const styleMatch = html.match(/style="([^"]*)"/);
    if (styleMatch) {
      const styles = styleMatch[1];
      return styles.includes('align-items: center;');
    }
    return false;
  };

  const getNextSet = async (page: number) => {
    return await getGroups(page)
  }

  useEffect(() => {
    const errorHandler = (field: string) => {
      scrollToElement(field);
    };

    traceFormikErrorField(errorHandler, values);
    setSelectedTemplateId(getValue('templateId') || "");
  }, []);

  const errors = useMemo(() => {
    const name = fields.name.error;
    const usecase = fields.usecase.error;
    const endPoint = fields.endPoint.error;
    const background = fields.background.error;
    const thankyouPage = fields.thankyouPage.error;
    const gaTrackingId = fields.gaTrackingId.error;
    const gtmTrackingId = fields.gtmTrackingId.error;
    const groupForContact = fields.groupForContact.error;
    const landingPageHtml = fields.landingPageHtml.error;
    const endPointHeaders = fields.endPointHeaders.error;
    const submitBackground = fields.submitBackground.error;
    const landingPageBackground = fields.landingPageBackground.error;
    const recipientsEmail = fields.recipientsEmail.name;
    const sendersEmail = fields.sendersEmail.name;
    const subject = fields.subject.name;

    return {
      [name]: getError(name, values),
      [usecase]: getError(usecase, values),
      [endPoint]: getError(endPoint, values),
      [background]: getError(background, values),
      [thankyouPage]: getError(thankyouPage, values),
      [gaTrackingId]: getError(gaTrackingId, values),
      [gtmTrackingId]: getError(gtmTrackingId, values),
      [landingPageHtml]: getError(landingPageHtml, values),
      [groupForContact]: getError(groupForContact, values),
      [endPointHeaders]: getError(endPointHeaders, values),
      [submitBackground]: getError(submitBackground, values),
      [landingPageBackground]: getError(landingPageBackground, values),
      [recipientsEmail]: getError(recipientsEmail, values),
      [sendersEmail]: getError(sendersEmail, values),
      [subject]: getError(subject, values),

    };
  }, [values]);

  return (
    <React.Fragment>
      <HeaderText id={fields.name.name}>Form Name</HeaderText>
      <FormSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Enter the name of your form</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            placeholder="Type here"
            value={getValue(fields.name.name)}
            error={Boolean(errors[fields.name.error])}
            onBlur={() => {
              setTouched(fields.name.name);
            }}
            onChange={(e: any) => {
              setValue(fields.name.setField, e.target.value);
            }}
          />
        </Grid>
        <ErrorText>{errors[fields.name.error]}</ErrorText>
      </FormSettingsContainer>
      <Divider />
      <HeaderText id={fields.background.name}>Background Settings</HeaderText>
      <BackgroundSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Enter URL of default background OR upload your image
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            placeholder="Type URL"
            value={getValue(fields.background.name)}
            error={Boolean(errors[fields.background.error])}
            onBlur={() => {
              setTouched(fields.background.name);
            }}
            onChange={(e: any) => {
              setValue(fields.background.setField, e.target.value);
            }}
          />
          <Grid item paddingTop={2}>
            <ChooseYourFileButton
              onClick={(e: any) => {
                e.preventDefault();
                handleOnUploadOpen(fields.background.setField);
              }}
            />
          </Grid>
        </Grid>
        <ErrorText>{errors[fields.background.error]}</ErrorText>
      </BackgroundSettingsContainer>
      <BackgroundSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer id={fields.submitBackground.name}>
            Enter URL of submit page background OR upload your image
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            placeholder="Type URL"
            value={getValue(fields.submitBackground.name)}
            error={Boolean(errors[fields.submitBackground.error])}
            onBlur={() => {
              setTouched(fields.submitBackground.name);
            }}
            onChange={(e: any) => {
              setValue(fields.submitBackground.setField, e.target.value);
            }}
          />
          <Grid item paddingTop={2}>
            <ChooseYourFileButton
              onClick={(e: any) => {
                e.preventDefault();
                handleOnUploadOpen(fields.submitBackground.setField);
              }}
            />
          </Grid>
        </Grid>
        <ErrorText>{errors[fields.submitBackground.error]}</ErrorText>
      </BackgroundSettingsContainer>
      <BackgroundSettingsContainer container>
        <Grid item xs={2}>
          <TextContainer>Background Color</TextContainer>
        </Grid>
        <Grid item xs={4}>
          <CustomToolTip className="background-tooltip" title="Background color will be applied only when background image is not provided">
            <InfoIcon fill="#a1a1a1" />
          </CustomToolTip>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <CustomizedColorInput
                open={editIdentifier === 7}
                closeHandler={handleOnEditClose}
                color={getValue(fields.backgroundColor.name)}
                setColor={(value: any) => {
                  setValue(fields.backgroundColor.setField, value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <ColorTextContainer>
                {getValue(fields.backgroundColor.name)}
              </ColorTextContainer>
            </Grid>
            <Grid item xs={6}>
              <EditButton
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOnEditOpen(7);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <ErrorText>{errors[fields.backgroundColor.error]}</ErrorText>
      </BackgroundSettingsContainer>
      <Divider />
      <HeaderText>Welcome Page Settings</HeaderText>
      <LandingPageSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Do you want a welcome page</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={landingPage}
            changeHandler={(e: any) => {
              setLandingPage(e?.target?.checked);
              values.setFieldValue("isLanding", e.target.checked);
              setDataFromModal({
                ...values?.values,
                isLanding: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </LandingPageSettingsContainer>
      {landingPage && (
        <React.Fragment>
          <LandingPageSettingsContainer container>
            <Grid item xs={6} paddingRight={5}>
              <TextContainer id={fields.landingPageBackground.name}>
                Enter URL of welcome page background OR upload your image
              </TextContainer>
            </Grid>
            <Grid item xs={6}>
              <CustomizedInput
                placeholder="Type URL"
                value={getValue(fields.landingPageBackground.name)}
                error={Boolean(errors[fields.landingPageBackground.error])}
                onBlur={() => {
                  setTouched(fields.landingPageBackground.name);
                }}
                onChange={(e: any) => {
                  setValue(
                    fields.landingPageBackground.setField,
                    e.target.value
                  );
                }}
              />
              <Grid item paddingTop={2}>
                <ChooseYourFileButton
                  onClick={(e: any) => {
                    e.preventDefault();
                    handleOnUploadOpen(fields.landingPageBackground.setField);
                  }}
                />
              </Grid>
            </Grid>
            <ErrorText>{errors[fields.landingPageBackground.error]}</ErrorText>
          </LandingPageSettingsContainer>
          <LandingPageSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer id={fields.landingPageHtml.name}>
                Please choose your welcome page type
              </TextContainer>
            </Grid>
            <Grid item xs={6}>
              <LandingPageTypeButtonsContainer>
                <LandingPageHtmlButtonWrapper>
                  <SelectableButton
                    title="HTML"
                    iconRenderer={() => (
                      <HtmlIcon
                        fill={
                          getValue(fields.landContentType.name) === "html"
                            ? globalColors.white
                            : globalColors.primary
                        }
                      />
                    )}
                    isSelected={
                      getValue(fields.landContentType.name) === "html"
                    }
                    onClick={() => {
                      setValue(fields.landContentType.setField, "html");
                      setValue(fields.landingPageHtml.setField, "");
                      setValue(
                        fields.landCustomContentColour.setField,
                        globalColors.white
                      );
                      setValue(
                        fields.landCustomContentFont.setField,
                        "Poppins"
                      );
                    }}
                  />
                </LandingPageHtmlButtonWrapper>
                <SelectableButton
                  title="Welcome message"
                  iconRenderer={() => <SettingsIcon />}
                  isSelected={
                    getValue(fields.landContentType.name) === "custom"
                  }
                  onClick={() => {
                    setValue(fields.landContentType.setField, "custom");
                    setValue(fields.landingPageHtml.setField, "");
                    setValue(
                      fields.landCustomContentColour.setField,
                      globalColors.white
                    );
                    setValue(fields.landCustomContentFont.setField, "Poppins");
                  }}
                />
              </LandingPageTypeButtonsContainer>
            </Grid>
          </LandingPageSettingsContainer>
          <LandingPageSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer>
                {getValue(fields.landContentType.name) === "html"
                  ? "Enter the HTML of your welcome page"
                  : "Enter the copy of your welcome page"}
              </TextContainer>
            </Grid>
            <Grid item xs={6}>
              <CustomizedInput
                placeholder={
                  getValue(fields.landContentType.name) === "html"
                    ? "Type HTML"
                    : "Provide a welcoming message and any essential information for your audience. keep your introduction concise and focused. Please limit your introduction to 150 words."
                }
                multiline
                minRows="2"
                maxRows="5"
                value={getValue(fields.landingPageHtml.name)}
                error={Boolean(errors[fields.landingPageHtml.error])}
                onBlur={() => {
                  setTouched(fields.landingPageHtml.name);
                }}
                onChange={(e: any) => {
                  setValue(fields.landingPageHtml.setField, e.target.value);
                }}
              />
              {getValue(fields.landContentType.name) === "html" && (
                <Grid
                  item
                  paddingTop={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <ChooseExistingTemplateButton
                    onClick={(event: React.MouseEvent<HTMLElement>) => {
                      event.preventDefault();
                      setTemplateIdentifier("1");
                    }}
                  />
                </Grid>
              )}
            </Grid>
            <ErrorText>{errors[fields.landingPageHtml.error]}</ErrorText>
          </LandingPageSettingsContainer>
          <LandingPageSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer>Welcome page text color</TextContainer>
            </Grid>
            <Grid item xs={6}>
              <Grid container alignItems="center">
                <Grid item xs={3}>
                  <CustomizedColorInput
                    open={editIdentifier === 1}
                    closeHandler={handleOnEditClose}
                    color={getValue(fields.landingPageTextColor.name)}
                    setColor={(value: any) => {
                      setValue(fields.landingPageTextColor.setField, value);
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <ColorTextContainer>
                    {getValue(fields.landingPageTextColor.name)}
                  </ColorTextContainer>
                </Grid>
                <Grid item xs={6}>
                  <EditButton
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleOnEditOpen(1);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </LandingPageSettingsContainer>
          <LandingPageSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer>Welcome page button color</TextContainer>
            </Grid>
            <Grid item xs={6}>
              <Grid container alignItems="center">
                <Grid item xs={3}>
                  <CustomizedColorInput
                    open={editIdentifier === 2}
                    closeHandler={handleOnEditClose}
                    color={getValue(fields.landingPageButtonColor.name)}
                    setColor={(value: any) => {
                      setValue(fields.landingPageButtonColor.setField, value);
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <ColorTextContainer>
                    {getValue(fields.landingPageButtonColor.name)}
                  </ColorTextContainer>
                </Grid>
                <Grid item xs={6}>
                  <EditButton
                    onClick={(e: any) => {
                      e.preventDefault();
                      handleOnEditOpen(2);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </LandingPageSettingsContainer>
        </React.Fragment>
      )}
      <LandingPageSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer id={fields.thankyouPage.name}>
            Enter Html of thank you page
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            placeholder="Paste your HTML"
            value={getValue(fields.thankyouPage.name)}
            error={Boolean(errors[fields.thankyouPage.error])}
            onBlur={() => {
              setTouched(fields.thankyouPage.name);
            }}
            multiline
            minRows="2"
            maxRows="5"
            onChange={(e: any) => {
              setValue(fields.thankyouPage.setField, e.target.value);
            }}
          />
          <FlexDiv><div><span>Vertical center</span>  <CustomizedSwitch
            checked={isVerticalAligned(getValue(fields.thankyouPage.name))}
            changeHandler={(e: any) => {
              setValue(fields.thankyouPage.setField, generateHtml(getValue(fields.thankyouPage.name), isHorizontalAligned(getValue(fields.thankyouPage.name)), e.target.checked));
            }}
          /></div><div><span>Horizontal center</span>  <CustomizedSwitch
            checked={isHorizontalAligned(getValue(fields.thankyouPage.name))}
            changeHandler={(e) => {
              setValue(fields.thankyouPage.setField, generateHtml(getValue(fields.thankyouPage.name), e.target.checked, isVerticalAligned(getValue(fields.thankyouPage.name))));
            }}
          /></div></FlexDiv>
          <Grid item paddingTop={2}>
            <ChooseExistingTemplateButton
              onClick={(event: React.MouseEvent<HTMLElement>) => {
                event.preventDefault();
                setTemplateIdentifier("2");
              }}
            />
          </Grid>
        </Grid>
        <ErrorText>{errors[fields.thankyouPage.error]}</ErrorText>
      </LandingPageSettingsContainer>
      <Divider />
      <ExtraHeaderText>Conversational Form Settings</ExtraHeaderText>
      <HeaderText>Basic Settings</HeaderText>
      <BasicSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Application</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSingleSelectDropdown
            value={applicationPopupData}
            setValue={(e: string) => setApplicationPopupData(e)}
            dataProvider={Application}
          />
        </Grid>
      </BasicSettingsContainer>
      <BasicSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Department</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSingleSelectDropdown
            value={departmentPopupData}
            setValue={(e: string) => setDepartmentPopupData(e)}
            dataProvider={Department}
          />
        </Grid>
      </BasicSettingsContainer>
      <BasicSettingsContainer container id={fields.usecase.name}>
        <Grid item xs={6}>
          <TextContainer>Use case</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            placeholder="Type your use case"
            value={getValue(fields.usecase.name)}
            error={Boolean(errors[fields.usecase.error])}
            onBlur={() => {
              setTouched(fields.usecase.name);
            }}
            onChange={(e: any) => {
              setValue(fields.usecase.setField, e.target.value);
            }}
          />
        </Grid>
        <ErrorText>{errors[fields.usecase.error]}</ErrorText>
      </BasicSettingsContainer>
      <BasicSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Do you want a Watermark</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={watermark}
            changeHandler={(e: any) => {
              setWatermark(e.target.checked);
            }}
          />
        </Grid>
      </BasicSettingsContainer>
      {watermark && (
        <BasicSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer>Watermark position</TextContainer>
          </Grid>
          <Grid item xs={6}>
            <CustomizedSingleSelectDropdown
              value={watermarkPosition}
              setValue={(e: string) => setWatermarkPosition(e)}
              dataProvider={Position}
            />
          </Grid>
        </BasicSettingsContainer>
      )}
      <HeaderText>Contacts</HeaderText>
      <BasicSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Do you want to save the submissions as contacts?</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={saveContact}
            changeHandler={(e: any) => {
              setSaveContact(e.target.checked);
              setValue("saveContact", e.target.checked);
              setDataFromModal({
                ...values?.values,
                saveContact: e.target.checked,
                contactGroup: e.target.checked
                  ? values?.values?.contactGroup
                  : "",
              });
              if (!e.target.checked) setContactGroup("");
            }}
          />
        </Grid>
      </BasicSettingsContainer>
      {saveContact && (
        <BasicSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer id={fields.groupForContact.name}>
              Select the group name the contact to be stored
            </TextContainer>
          </Grid>
          <Grid item xs={6}>
            <Grid container alignItems="center">
              <Grid item xs={8}>
                <InfiniteScrollSelect
                  getNextSet={getNextSet}
                  value={contactGroup}
                  onChange={(e: string) => {
                    setContactGroup(e);
                    setValue("contactGroup", e);
                    setDataFromModal({ ...values?.values, contactGroup: e });
                  }}
                  page={page}
                  setPage={setPage}
                  hasMore={hasMore}
                  setHasMore={setHasMore}
                  options={groupsList}
                  setOptions={setGroupsList}
                  error={Boolean(errors[fields.groupForContact.error])}
                />
              </Grid>
              <Grid item xs={4}>
                <AddGroupButton
                  onClick={() => {
                    setGroupPopupOpen(true);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <ErrorText>{errors[fields.groupForContact.error]}</ErrorText>
        </BasicSettingsContainer>
      )}
      <HeaderText>General Settings</HeaderText>
      <GeneralSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Text color</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <CustomizedColorInput
                open={editIdentifier === 3}
                closeHandler={handleOnEditClose}
                color={getValue(fields.textColor.name)}
                setColor={(value: any) => {
                  setValue(fields.textColor.setField, value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <ColorTextContainer>
                {getValue(fields.textColor.name)}
              </ColorTextContainer>
            </Grid>
            <Grid item xs={6}>
              <EditButton
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOnEditOpen(3);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Button color</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <CustomizedColorInput
                open={editIdentifier === 4}
                closeHandler={handleOnEditClose}
                color={getValue(fields.buttonColor.name)}
                setColor={(value: any) => {
                  setValue(fields.buttonColor.setField, value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <ColorTextContainer>
                {getValue(fields.buttonColor.name)}
              </ColorTextContainer>
            </Grid>
            <Grid item xs={6}>
              <EditButton
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOnEditOpen(4);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Button text color</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <CustomizedColorInput
                open={editIdentifier === 5}
                closeHandler={handleOnEditClose}
                color={getValue(fields.buttonTextColor.name)}
                setColor={(value: any) => {
                  setValue(fields.buttonTextColor.setField, value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <ColorTextContainer>
                {getValue(fields.buttonTextColor.name)}
              </ColorTextContainer>
            </Grid>
            <Grid item xs={6}>
              <EditButton
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOnEditOpen(5);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer>Select loader color</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <CustomizedColorInput
                open={editIdentifier === 6}
                closeHandler={handleOnEditClose}
                color={getValue(fields.loaderColor.name)}
                setColor={(value: any) => {
                  setValue(fields.loaderColor.setField, value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <ColorTextContainer>
                {getValue(fields.loaderColor.name)}
              </ColorTextContainer>
            </Grid>
            <Grid item xs={6}>
              <EditButton
                onClick={(e: any) => {
                  e.preventDefault();
                  handleOnEditOpen(6);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </GeneralSettingsContainer>
      {editUUID && (
        <GeneralSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer>Form UUID</TextContainer>
          </Grid>
          <Grid item xs={6}>
            <TextContainer>{editUUID}</TextContainer>
          </Grid>
        </GeneralSettingsContainer>
      )}
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>Do you want to record video of user?</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={recordVideo}
            changeHandler={(e: any) => {
              setRecordVideo(e?.target?.checked);
              values.setFieldValue("recordVideo", e.target.checked);
              setDataFromModal({
                ...values?.values,
                recordVideo: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>Allow the user to submit new response?</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={values.getFieldProps('allowNewResponse').value ?? false}
            changeHandler={(e: any) => {
              values.setFieldValue("allowNewResponse", e.target.checked);
              setDataFromModal({
                ...values?.values,
                allowNewResponse: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Do you want to display the record video to user?
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={showRecordVideo}
            changeHandler={(e: any) => {
              setShowRecordVideo(e?.target?.checked);
              values.setFieldValue("showRecordVideo", e.target.checked);
              setDataFromModal({
                ...values?.values,
                showRecordVideo: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      <BasicSettingsContainer container>
        <Grid item xs={6}>
          <TextContainer> On submit send form submission to an email address.</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={getValue("sendResponseInEmail.isActive")}
            changeHandler={(e: any) => {
              setValue("sendResponseInEmail.isActive", e.target.checked);
              setDataFromModal({
                ...values?.values,
                sendResponseInEmail: {
                  isActive: e.target.checked,
                  sendersEmail: "",
                  recipientsEmail: [],
                  subject: ""
                }
              });
            }}
          />
        </Grid>
      </BasicSettingsContainer>
      {getValue("sendResponseInEmail.isActive") && <> <BasicSettingsContainer container id={fields.sendersEmail.name}>
        <Grid item xs={6}>
          <TextContainer>Sender's email (From):</TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedInput
            name={fields.sendersEmail.name}
            placeholder="Type sender's email"
            value={getValue(fields.sendersEmail.name)}
            error={Boolean(errors[fields.sendersEmail.name])}
            onBlur={() => {
              setTouched(fields.sendersEmail.name);
            }}
            onChange={(e: any) => {
              setValue(fields.sendersEmail.name, e.target.value);
            }}
          />
        </Grid>
        <ErrorText>{errors[fields.sendersEmail.name]}</ErrorText>
      </BasicSettingsContainer>
        <BasicSettingsContainer container id={fields.recipientsEmail.name}>
          <Grid item xs={6}>
            <TextContainer>Recipient email (To):</TextContainer>
          </Grid>
          <Grid item xs={6}>
            <InputChipComponent chips={getValue(fields.recipientsEmail.name)} setChips={(e) => values.setFieldValue(fields.recipientsEmail.name, e)} placeholder={"Type recipient's email"} error={Boolean(errors[fields.recipientsEmail.name])} onBlur={() => setTouched(fields.recipientsEmail.name)} />
          </Grid>
          <ErrorText>{errors[fields.recipientsEmail.name]}</ErrorText>
        </BasicSettingsContainer>
        <BasicSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer>Subject:</TextContainer>
          </Grid>
          <Grid item xs={6}>
            <CustomizedInput
              name={fields.subject.name}
              placeholder="Type email subject"
              value={getValue(fields.subject.name)}
              error={Boolean(errors[fields.subject.name])}
              onBlur={() => {
                setTouched(fields.subject.name);
              }}
              onChange={(e: any) => {
                setValue(fields.subject.name, e.target.value);
              }}
            />
          </Grid>
          <ErrorText>{errors[fields.subject.name]}</ErrorText>
        </BasicSettingsContainer></>}
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Do you want to send the form response back to the user?
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={sendResponseToUser}
            changeHandler={(e: any) => {
              setSendResponseToUser(e?.target?.checked);
              values.setFieldValue("sendResponseToUser", e.target.checked);
              setDataFromModal({
                ...values?.values,
                sendResponseToUser: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Do you want to send this form data to your end point ?
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={endPointAvailable}
            changeHandler={(e: any) => {
              setEndPointAvailable(e?.target?.checked);
              values.setFieldValue("endPointAvailable", e.target.checked);
              setDataFromModal({
                ...values?.values,
                endPointAvailable: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      {endPointAvailable && (
        <React.Fragment>
          <GeneralSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer id={fields.endPoint.name}>
                Enter url of the endpoint
              </TextContainer>
            </Grid>
            <Grid item xs={6}>
              <CustomizedInput
                placeholder="Type URL"
                value={getValue(fields.endPoint.name)}
                error={Boolean(errors[fields.endPoint.error])}
                onBlur={() => {
                  setTouched(fields.endPoint.name);
                }}
                onChange={(e: any) => {
                  setValue(fields.endPoint.setField, e.target.value);
                }}
              />
            </Grid>
            <ErrorText>{errors[fields.endPoint.error]}</ErrorText>
          </GeneralSettingsContainer>
          <GeneralSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer>Select method of the endpoint</TextContainer>
            </Grid>
            <Grid item xs={6}>
              <Select disabled size="small" value="post" sx={{ height: 30 }}>
                <MenuItem value="post">
                  <TextContainer>POST</TextContainer>
                </MenuItem>
              </Select>
            </Grid>
          </GeneralSettingsContainer>
          <GeneralSettingsContainer container>
            <Grid item xs={6}>
              <TextContainer>Enter the headers of the endpoint</TextContainer>
            </Grid>
            <Grid item xs={6}>
              <CustomizedInput
                placeholder="Type Headers"
                value={getValue(fields.endPointHeaders.name)}
                error={Boolean(errors[fields.endPointHeaders.error])}
                onBlur={() => {
                  setTouched(fields.endPointHeaders.name);
                }}
                onChange={(e: any) => {
                  setValue(fields.endPointHeaders.setField, e.target.value);
                }}
              />
            </Grid>
            <ErrorText>{errors[fields.endPointHeaders.error]}</ErrorText>
          </GeneralSettingsContainer>
        </React.Fragment>
      )}
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Do you want to add your Google analytics in form?
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={gaAvailable}
            changeHandler={(e: any) => {
              setGaAvailable(e?.target?.checked);
              values.setFieldValue("gaAvailable", e.target.checked);
              setDataFromModal({
                ...values?.values,
                gaAvailable: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      {gaAvailable && (
        <GeneralSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer>
              Enter your Google analytics MEASUREMENT ID
            </TextContainer>
          </Grid>
          <Grid item xs={6}>
            <CustomizedInput
              placeholder="Type here"
              value={getValue(fields.gaTrackingId.name)}
              error={Boolean(errors[fields.gaTrackingId.error])}
              onBlur={() => {
                setTouched(fields.gaTrackingId.name);
              }}
              onChange={(e: any) => {
                setValue(fields.gaTrackingId.setField, e.target.value);
              }}
            />
          </Grid>
          <ErrorText>{errors[fields.gaTrackingId.error]}</ErrorText>
        </GeneralSettingsContainer>
      )}
      <GeneralSettingsContainer container>
        <Grid item xs={6} paddingRight={5}>
          <TextContainer>
            Do you want to add your GTM in form to get form data in analytics?
          </TextContainer>
        </Grid>
        <Grid item xs={6}>
          <CustomizedSwitch
            checked={gtmAvailable}
            changeHandler={(e: any) => {
              setGtmAvailable(e?.target?.checked);
              values.setFieldValue("gtmAvailable", e.target.checked);
              setDataFromModal({
                ...values?.values,
                gtmAvailable: e?.target?.checked,
              });
            }}
          />
        </Grid>
      </GeneralSettingsContainer>
      {gtmAvailable && (
        <GeneralSettingsContainer container>
          <Grid item xs={6}>
            <TextContainer>Enter your GTM tag</TextContainer>
          </Grid>
          <Grid item xs={6}>
            <CustomizedInput
              placeholder="Type here"
              value={getValue(fields.gtmTrackingId.name)}
              error={Boolean(errors[fields.gtmTrackingId.error])}
              onBlur={() => {
                setTouched(fields.gtmTrackingId.name);
              }}
              onChange={(e: any) => {
                setValue(fields.gtmTrackingId.setField, e.target.value);
              }}
            />
          </Grid>
          <ErrorText>{errors[fields.gtmTrackingId.error]}</ErrorText>
        </GeneralSettingsContainer>
      )}
      <FileUploadDialog
        open={Boolean(uploadIdentifier)}
        submitHandler={handleOnUploadClose}
        editUUID={editUUID}
      />
      <UserTemplatesDialog
        open={Boolean(templateIdentifier)}
        closeHandler={onTemplateCloseHandler}
        submitHandler={onTemplateSubmitHandler}
        renderContent={() => {
          return (
            <UserTemplates
              selectedTemplateId={selectedTemplateId}
              setSelectedTemplateId={setSelectedTemplateId}
            />
          );
        }}
      />
      <Snackbar
        open={toasterConfig?.open}
        autoHideDuration={3000}
        onClose={() => {
          setToasterConfig({
            open: false,
            severity: toasterConfig.severity,
            message: "",
          });
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          severity={toasterConfig?.severity}
          onClose={() => {
            setToasterConfig({
              open: false,
              severity: toasterConfig.severity,
              message: "",
            });
          }}
        >
          {toasterConfig?.message}
        </Alert>
      </Snackbar>
      {groupPopupOpen && (
        <AddGroupPopup
          setOpen={setGroupPopupOpen}
          title={"Add Group"}
          setResponse={setGroupResponse}
          response={groupResponse}
          handleSave={handleSave}
          btnLoading={btnLoading}
        />
      )}
    </React.Fragment>
  );
}
